import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="homepage-footer">
      <div className="footer-content ">
        <div className="footer-main borderbottom">
          <div className="footer-brand">
            <img src="/Images/sllogoblack.png" alt="SoapLab" className="footer-logo" />
          </div>
          <div className="footer-nav">
            <Link to="/help">Help Center</Link>
            <Link to="/contact">Contact Us</Link>
            <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="footer-back-to-top">
              Back to the top
            </button>

            <div className="footer-social">
              <a
                href="https://www.youtube.com/@soaplabin"
                target="_blank"
                rel="noreferrer"
                aria-label="SoapLab on YouTube"
              >
                <img
                  src="/Images/social icons/youtube.svg"
                  alt=""
                  className="footer-social-icon"
                />
              </a>
              <a
                href="https://www.facebook.com/soaplabin"
                target="_blank"
                rel="noreferrer"
                aria-label="SoapLab on Facebook"
              >
                <img
                  src="/Images/social icons/facebook.svg"
                  alt=""
                  className="footer-social-icon"
                />
              </a>
              <a
                href="https://www.instagram.com/soaplab.in"
                target="_blank"
                rel="noreferrer"
                aria-label="SoapLab on Instagram"
              >
                <img
                  src="/Images/social icons/instagram.svg"
                  alt=""
                  className="footer-social-icon"
                />
              </a>
            </div>

          </div>
        </div>
        <div className="footer-bottom">
          <div className="footer-copy">
            <span>© SoapLab</span>
            <Link to="/terms">Terms of Use</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/refund-policy">Refund Policy</Link>
            <Link to="/shipping-policy">Shipping Policy</Link>
          </div>
          <div className="footer-rights">
            All Rights Reserved
          </div>
        </div>
      </div>
    </footer>
  );
}
